import { Box, Button, Stack, styled, Typography } from "@mui/material";
import { useDispatch } from "react-redux";
import aIIcon from "../../assets/images/chats/aIIcon.svg";
import vectorIcon from "../../assets/images/chats/VectorIcon.svg";
import folderIcon from "../../assets/images/chats/FolderIcon.svg";
import topicIcon from "../../assets/images/chats/topic.svg";
import searchIcon from "../../assets/images/chats/searchIcon.svg";
import blackHistoryIcon from "../../assets/images/chats/blackHistoryIcon.svg";
import fileIcon from "../../assets/images/chats/fileIcon.svg";
import black_back_arrow from "../../assets/images/chats/black_back_arrow.svg";
import { clearCurrentAiSessionData } from "../../appStore/actions/ArkchatGroup/action";
import addmember_icon from "../../assets/images/chats/addmember_icon.svg";
import {
  handleScrollToBottom,
  handleShowAIScreen,
  handleStarMsgScreen,
} from "../../appStore/actions/AppState/action";
import { useTranslation } from "react-i18next";
import LableToolTip from "../LableToolTip";
import useAppSelectors from "../../customHooks/useAppSelectors";
import GroupInfoHeader from "../../page/chat/Tabs/GroupInfoHeader";
import { ActionButton } from "../CustomButtons/CustomButtons";
import PersonFloat from "../../assets/images/chats/personFloatBtn.svg";
import { colorSchemes, fontSizeSchemes } from "../../assets/commonFunction";
import SearchInputFromGroupInfo from "../../page/chat/Tabs/SearchInputFromGroupInfo";
import session from "../../utils/helper";

export const SearchBox = styled("div")({
  display: "flex",
  alignItems: "center",
  padding: "0.13rem 0.3rem",
  border: "1px solid rgb(24 50 66 / 50%)",
  justifyContent: "space-between",
  backgroundColor: "#fff",
  borderRadius: "3px",
});

export const CustomInput = styled("input")({
  // width: "90%",
  width: "calc(100% - 30px)",
  border: "none",
  outline: "none",
  "&:focus": {
    border: "none",
  },
});

export const SearchButton = styled(Button)({
  backgroundColor: "#DB0011",
  color: "#fff",
  borderRadius: "50%",
  width: "1.5rem",
  height: "1.5rem",
  minWidth: "unset",
  minHeight: "unset",
  padding: 0,
  "&:hover": {
    backgroundColor: "#DB0011",
    color: "#fff",
  },
});
export const ChatSearchButton = styled(Button)({
  // backgroundColor: "#DB0011",
  backgroundColor: "transparent",
  color: "#fff",
  borderRadius: "50%",
  width: "23px",
  height: "23px",
  margin: "1px",
  minWidth: "unset",
  minHeight: "unset",
  boxShadow: "none",

  "&:hover": {
    // backgroundColor: "#DB0011",
    backgroundColor: "transparent",
    boxShadow: "none",
    color: "#fff",
  },
});

export const SmallIcon = styled("img")({
  width: "1rem",
  height: "1rem",
});
export const CustomIcon = styled("img")({
  width: "1rem",
  height: "1rem",
});

const ScreenSearchSection = ({
  setisTopicOpen,
  setMediaFilesOpen,
  handleAddgroupMember,
  isTopicOpen,
  setAiQueryHistory,
  setTempAiQuery,
  setShareAiText,
  setShowStaredAiHistory,
  showStaredAiHistory,
  isAiQueryHistory,
  handleBacktoMessage,
  isSearchGroupInfoOpen,
  handleSearch,
  isPrivateChatOn,
  aiComponentRef
}) => {
  const { t } = useTranslation();
  const appContent = t("AppContent", { returnObjects: true });
  const { selectedGroup, isAiScreenActive, showStarMessage } = useAppSelectors();
  const isThreadScreen = session.get("isThreadScreen"); 
  

  const dispatch = useDispatch();
  const handleTopicClick = () => {
    if (selectedGroup && selectedGroup?.isGroup && !isTopicOpen) {
      setisTopicOpen(true);
    }
  };
  const handleAiBtnCLick = () => {
    if (selectedGroup) {
      setisTopicOpen(false);
      dispatch(handleShowAIScreen(true));
    }
  };
  const handleAiBackBtnClick = () => {
    dispatch(clearCurrentAiSessionData());
    dispatch(handleShowAIScreen(false));
    setAiQueryHistory(false);
    setTempAiQuery(false);
    setShareAiText(false);
  };
  const handleClearCurrentAiSession = () => {
    aiComponentRef.current?.resetQuery()
  };
  return (
    <>
      {(!isThreadScreen || isAiScreenActive||isThreadScreen) && (
        <Stack
          spacing={"0.28rem"}
          mt={"0.37rem"}
          alignItems="center"
          direction="row"
        >
          <Stack alignItems="center" direction="row" spacing={"0.35rem"}>
            {isAiScreenActive ? (
              <>
                <Box>
                  <Button
                    onClick={() => selectedGroup && handleAiBackBtnClick()}
                    size="small"
                    variant="contained"
                    sx={{
                      alignContent: "center",
                      textTransform: "none",
                      borderRadius: "0.15rem",
                      backgroundColor: "#fff",
                      padding: "4px",
                      color: "#000000",
                      border: "1px solid #000000",
                      height: "30px",
                      minHeight: "unset",
                      "&:hover": {
                        backgroundColor: "#fff",
                        color: "#000000",
                        border: "1px solid #000000",
                      },
                    }}
                  >
                    <img
                      style={{ marginRight: "0.3rem" }}
                      src={black_back_arrow}
                      alt=""
                    />
                    {appContent?.KEY11}
                  </Button>
                </Box>
                <Box>
                  <ActionButton
                    variant="outlined"
                    backgroundColor="#ffff"
                    borderColor="#000000"
                    onClick={() => setAiQueryHistory(true)}
                    size="small"
                  >
                    <SmallIcon src={blackHistoryIcon} />
                  </ActionButton>
                </Box>
              </>
            ) : (
              <>
                {/* {!isAiScreenActive && (
              <LableToolTip title={appContent?.KEY252}>
                <Box>
                  <ActionButton
                    variant="outlined"
                    size="small"
                    backgroundColor="#ffff"
                    borderColor="#000000"
                    onClick={handleTopicClick}
                  >
                    <CustomIcon src={topicIcon} />
                  </ActionButton>
                </Box>
              </LableToolTip>
            )} */}
                {selectedGroup?.isGroup ? (
                  <LableToolTip title={appContent?.KEY253}>
                    <Box>
                      <ActionButton
                        variant="outlined"
                        size="small"
                        // backgroundColor={colorSchemes.themeRedColor}
                        // borderColor={colorSchemes.themeRedColor}
                        backgroundColor={showStaredAiHistory ? "grey" : "#ffff"}
                        borderColor="#000000"
                        onClick={handleAddgroupMember}
                      >
                        <SmallIcon src={PersonFloat} />
                      </ActionButton>
                    </Box>
                  </LableToolTip>
                ) : null}

                {/* <LableToolTip title={appContent?.KEY253}>
                  <Box>
                    <ActionButton
                      variant="outlined"
                      size="small"
                      backgroundColor="#ffff"
                      borderColor="#000000"
                      onClick={handleAddgroupMember}
                    >
                      <img
                        style={{ width: "95%" }}
                        src={addmember_icon}
                        alt="add member"
                      />
                    </ActionButton>
                  </Box>
                </LableToolTip> */}
              </>
            )}
          </Stack>

          <Stack maxWidth={isTopicOpen ? "88.7%" : "93.3%"} flex={3}>
            <GroupInfoHeader
              isTopicOpen={isTopicOpen}
              setMediaFilesOpen={setMediaFilesOpen}
              handleSearch={handleSearch}
            />
            {/* <SearchBox sx={{width: '100%'}}>
                <CustomInput fontSize={fontSizeSchemes.font14} fontWeight={400}  type="text" placeholder="Ask Arkchat Bot or Search" />
                <Box>
                  <ChatSearchButton size="small" variant="contained">
                    <SmallIcon src={searchIcon} />
                  </ChatSearchButton>
                </Box>
              </SearchBox> */}
          </Stack>

          <Stack alignItems="center" direction="row" spacing={"0.35rem"}>
            {isAiScreenActive ? (
              <>
                {/* <LableToolTip title={appContent?.KEY255}>
                  <Box>
                    <ActionButton
                      variant="outlined"
                      size="small"
                      backgroundColor={showStaredAiHistory ? "grey" : "#ffff"}
                      borderColor="#000000"
                      onClick={() =>
                        selectedGroup &&
                        isAiQueryHistory &&
                        setShowStaredAiHistory(true)
                      }
                    >
                      <SmallIcon src={vectorIcon} />
                    </ActionButton>
                  </Box>
                </LableToolTip> */}
                <Box>
                  <Button
                    onClick={() =>
                      selectedGroup && handleClearCurrentAiSession()
                    }
                    size="small"
                    variant="contained"
                    sx={{
                      textTransform: "none",
                      borderRadius: "0.15rem",
                      backgroundColor: "#fff",
                      border: "1px solid #000000",
                      padding: "4px",
                      color: "#000000",
                      height: "30px",
                      minHeight: "unset",
                      "&:hover": {
                        backgroundColor: "#fff",
                        color: "#000000",
                        border: "1px solid #000000",
                      },
                    }}
                  >
                    <Typography variant="h5" fontSize={"0.75rem"}>
                      {appContent?.KEY10}
                    </Typography>
                  </Button>
                </Box>
              </>
            ) : (
              <>
                {!isAiScreenActive && (
                  <LableToolTip title={appContent?.KEY252}>
                    <Box>
                      <ActionButton
                        variant="outlined"
                        size="small"
                        backgroundColor={""}
                        borderColor="#000000"
                        onClick={handleTopicClick}
                      >
                        <SmallIcon src={topicIcon} />
                      </ActionButton>
                    </Box>
                  </LableToolTip>
                )}
                <LableToolTip title={appContent?.KEY255}>
                  <Box>
                    <ActionButton
                      variant="outlined"
                      size="small"
                      backgroundColor={showStarMessage ? "white" : ""}
                      borderColor="#000000"
                      onClick={() => {
                        selectedGroup &&
                          dispatch(handleStarMsgScreen(!showStarMessage));
                        dispatch(handleScrollToBottom(true));
                      }}
                    >
                      <SmallIcon src={vectorIcon} />
                    </ActionButton>
                  </Box>
                </LableToolTip>
              </>
            )}
          </Stack>
        </Stack>
      )}
    </>
  );
};

export default ScreenSearchSection;

